import React from 'react';
import TablePagination from '@material-ui/core/TablePagination';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    padding: 0,
    border: 'none',
  },
}));

const ShopifyPageSelect = ({
  pageSize,
  currentPage,
  setCurrentPage,
  numberOfResults,
  isLoading,
  setPageSize,
  pageSizeOptions,
}) => {
  const classes = useStyles();

  if (!numberOfResults || isLoading) {
    return (
      <div />
    );
  }

  return (
    <TablePagination
      count={numberOfResults}
      onPageChange={(e, page) => setCurrentPage(page + 1)}
      page={currentPage - 1}
      rowsPerPage={pageSize}
      rowsPerPageOptions={pageSizeOptions}
      labelRowsPerPage="Products"
      onRowsPerPageChange={(e) => setPageSize(e.target.value)}
      classes={{ root: classes.root }}
    />
  );
};

export default ShopifyPageSelect;
